/* https://jsfiddle.net/q5qzmv68/7/ */
var timer;
var timerResume;
var duration = 3000;
var doSlide = false;
var i = 0;
// var array = ["f1","f2","f3","f4","f5","f6","f7","f8","f9","f10","f11"]
var array = ['f10', 'f2', 'f8', 'f4', 'f11', 'f5', 'f9', 'f7', 'f3', 'f1', 'f6'];

function Slide() {
  timer = setTimeout(function () {
    if (doSlide == true) {
      Slide();
      nextSlide();
      // log(array[i])
      i++;

      if (i == 11) i = 0;
    } else if (doSlide == false) {
      console.log('Sliding aborted untill next runSlider() call!');
      clearTimeout(timer);
      clearTimeout(timerResume);
    }
  }, duration);
}

function runSlider() {
  doSlide = true;
  Slide();
}

function pauseSlider() {
  doSlide = false;
  clearTimeout(timer);
  clearTimeout(timerResume);
}

function nextSlide() {
  $('svg .active').removeClass('active');
  $('#' + array[i]).addClass('active');
}

function hoverSlider() {
  $('svg')
    .on('mousemove', function () {
      // log('mousemove');
      pauseSlider();
      $('#schwarze_Flaechen').addClass('hover');

      timerResume = setTimeout(function () {
        runSlider();
        $('#schwarze_Flaechen').removeClass('hover');
        // log('timerResume')
      }, 5000);
    })
    .on('mouseleave', function () {
      runSlider();
      clearTimeout(timerResume);
      $('#schwarze_Flaechen').removeClass('hover');
      // log('mouseleave')
    });
}

/**
 * do stuff
 *
 */

window.addEventListener(
  'load',
  function () {
    $('body').removeClass(' is-loading');
    // document.getElementById('f3').classList.remove('active');
    setTimeout(function () {
      $('#f3').removeClass('active');
    }, duration);
    runSlider();
    hoverSlider();

    // console.log('window - load - capture');
  },
  true
);
